const changeThemeAction = () => ({
  type: 'TOGGLE_THEME',
});

const changeLangAction = () => ({
  type: 'TOGGLE_LANG',
});

export { changeLangAction, changeThemeAction };
